import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#004AAD" }, // MSI blue
    background: { default: "#F8F9FB", paper: "#FFFFFF" },
  },
  typography: {
    fontFamily: "Inter, Helvetica, Arial, sans-serif",
    fontSize: 13.5,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          borderBottom: "1px solid #E5E8EB",
          boxShadow: "none",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          borderRadius: 8,
          backgroundColor: "#fff",
          fontSize: "0.9rem",
        },
        columnHeaders: {
          backgroundColor: "#F0F6FF",
          color: "#004AAD",
          fontWeight: 600,
          fontSize: "0.95rem",
          borderBottom: "1px solid #E0E0E0",
        },
        row: {
          "&:nth-of-type(odd)": { backgroundColor: "#FAFBFC" },
          "&:hover": {
            backgroundColor: "#EEF5FF",
            transition: "background 0.15s ease-in-out",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;
